import React, { useState } from 'react';
import LoginTemplate from '../../templates/Login';

export default (props) => {
  return <LoginTemplate load={props.load}>{props.children}</LoginTemplate>;
};
